import React from 'react';
import { Grid, List, SortAsc, Calendar, Eye } from 'lucide-react';
import { SearchFilters } from '../../types/search';

interface ViewControlsProps {
  filters: SearchFilters;
  onFiltersChange: (filters: SearchFilters) => void;
}

export const ViewControls: React.FC<ViewControlsProps> = ({
  filters,
  onFiltersChange,
}) => {
  const handleSortChange = (sortBy: SearchFilters['sortBy']) => {
    onFiltersChange({ ...filters, sortBy });
  };

  const handleViewModeChange = (viewMode: SearchFilters['viewMode']) => {
    onFiltersChange({ ...filters, viewMode });
  };

  return (
    <div className="flex items-center justify-between bg-white rounded-lg shadow p-4">
      {/* Tri */}
      <div className="flex items-center space-x-2">
        <span className="text-sm text-gray-500">Trier par:</span>
        <div className="flex rounded-md shadow-sm">
          <button
            onClick={() => handleSortChange('alpha')}
            className={
              "px-3 py-2 text-sm font-medium rounded-l-md border border-r-0 " +
              (filters.sortBy === 'alpha'
                ? "bg-primary-100 text-primary-700"
                : "text-gray-700 hover:bg-gray-50")
            }
          >
            <SortAsc className="h-4 w-4" />
          </button>
          <button
            onClick={() => handleSortChange('date')}
            className={
              "px-3 py-2 text-sm font-medium border " +
              (filters.sortBy === 'date'
                ? "bg-primary-100 text-primary-700"
                : "text-gray-700 hover:bg-gray-50")
            }
          >
            <Calendar className="h-4 w-4" />
          </button>
          <button
            onClick={() => handleSortChange('views')}
            className={
              "px-3 py-2 text-sm font-medium rounded-r-md border border-l-0 " +
              (filters.sortBy === 'views'
                ? "bg-primary-100 text-primary-700"
                : "text-gray-700 hover:bg-gray-50")
            }
          >
            <Eye className="h-4 w-4" />
          </button>
        </div>
      </div>

      {/* Mode d'affichage */}
      <div className="flex rounded-md shadow-sm">
        <button
          onClick={() => handleViewModeChange('grid')}
          className={
            "px-3 py-2 text-sm font-medium rounded-l-md border border-r-0 " +
            (filters.viewMode === 'grid'
              ? "bg-primary-100 text-primary-700"
              : "text-gray-700 hover:bg-gray-50")
          }
        >
          <Grid className="h-4 w-4" />
        </button>
        <button
          onClick={() => handleViewModeChange('list')}
          className={
            "px-3 py-2 text-sm font-medium rounded-r-md border border-l-0 " +
            (filters.viewMode === 'list'
              ? "bg-primary-100 text-primary-700"
              : "text-gray-700 hover:bg-gray-50")
          }
        >
          <List className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};
